module.exports = __webpack_public_path__ + "img/SketchPng07814e539244c4d832bfb1bbe2ac7cff2b735b4c5d9fbbbb41e09c7e8d8c3cfc.63a97dff.png";